<template>
    <div class="mt-5 flex flex-col">
        <div class="grid-flow-row lg:grid lg:auto-rows-max lg:grid-cols-[1fr,400px]">
            <div class="row-span-1 w-full bg-grey-10 border-grey-20 border-1 text-grey-70 mt-3 mb-5 p-6 text-base personal-page">
                <h3>Additional Info</h3>
                <p>{{ agency.Accreditations }}</p>

                <p><strong>We have offices located at the following addresses:</strong></p>
                <ul>
                    <li v-for="(addr,tag) in addressesForListings(agency.branches)">
                        {{ filterASCII(addr) }}
                    </li>
                </ul>

                <template v-if="hasRecruitedLevels(agency.RecruitmentLevelsCovered)">
                    <p>
                        <strong>We recruit candidates at the following experience levels:</strong>
                    </p>
                    <p>
                        {{ Object.values(getRecruitedLevels(agency.RecruitmentLevelsCovered)).join(', ') }}
                    </p>
                </template>
                
                <template v-if="hasRecruitedIndustries">
                    <p>
                        <strong>We recruit in the following industries:</strong>
                    </p>
                    <p>
                        {{ agency.industries.replace(/,/g,', ') }}
                    </p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import filterASCII from 'Mixins/text.js';
import { mapGetters, mapState } from "vuex";

export default {
    name: 'AdditionalInfo',
    mixins: [ filterASCII ],
    computed: {
        ...mapState('agency', ['parameters', 'agency', 'branches']),
        ...mapGetters('agency', [
            'getRecruitedLevels',
            'hasRecruitedLevels',
            'hasRecruitedIndustries'
        ]),
    },
    mounted() {
        console.log('Arrived at AdditionalInfo component');
    }
}

</script>
